/**
 * Discreet "🛠️ Dev access" link for the homepage / select screen.
 *
 * Only renders when the signed-in user is a dev (per the email allowlist
 * in `bugReports.ts`'s isDev() helper, plus the `userPreferences.isDev`
 * field). Non-devs see nothing — the link is invisible to them.
 *
 * Must be mounted inside a Convex provider context (auth-on mode). The
 * caller in App.js gates this on `viewerContext !== undefined`.
 */

import React from 'react';
import { useIsDev } from '../hooks/useBugReports.js';

const isLocalhost = (() => {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return h === 'localhost' || h === '127.0.0.1' || h === '0.0.0.0';
})();

export default function DevAccessLink({ onNavigate }) {
  const isDev = useIsDev();
  // Show on localhost (dev environment, regardless of who's signed in)
  // OR for the maintainer account in production. Other users see nothing.
  if (!isLocalhost && !isDev) return null;
  return (
    <div style={{ marginTop: 28, textAlign: 'center' }}>
      <button
        onClick={onNavigate}
        style={{
          padding: '6px 14px',
          background: 'rgba(155,89,182,0.08)',
          border: '1px dashed rgba(155,89,182,0.4)',
          borderRadius: 5,
          color: '#9b59b6',
          cursor: 'pointer',
          fontSize: '0.75rem',
          fontWeight: 500,
        }}
      >
        🛠️ Dev access — view all reports
      </button>
      <div style={{ fontSize: '0.6rem', color: '#666', marginTop: 4, opacity: 0.7 }}>
        {isDev ? '(visible only to you)' : '(localhost only)'}
      </div>
    </div>
  );
}
